// Mount the Compute module: hand `createComputeModule` a lazy host (`./compute-host`, which holds the
// heavy app imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the
// routes and the catalog scopes from HERE, so the module cannot be mounted unregistered. Two pages
// render things of the module outside its console and may not import a package or this file, so the
// root hands them loaders: the catalog detail page reads `catalogLandings.loadComputeLanding` and the
// full-window console popup reads `computeConsoles.loadInstanceConsole`. Two places import this file,
// because there are two ways in: `service-modules.ts` (the services hub) and `src/routers/index.tsx`
// (the popup is outside the hub, so its lazy chunk loads this file first). This file must stay light:
// it is in the entry chunk. The HTTP clients are not members: the data layer reads the shared registry
// (`@vnetwork/margarita-core/http`).
import { createComputeModule } from '@vnetwork/margarita-compute';
import { catalogLandings } from '@/components/catalog-landings';
import { computeConsoles } from '@vnetwork/margarita-shell/compute-console';

export const compute = createComputeModule(() => import('./compute-host').then((m) => m.computeHost));

catalogLandings.loadComputeLanding = compute.loadActivateLanding;
computeConsoles.loadInstanceConsole = compute.loadInstanceConsole;
